import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { EntGrossProductCollection } from "../../../models/organic/grossProductCollection";
import { EntGrossProductCollectionFilter } from "../../../models/filters/organic/grossProductCollectionFilter";
import { Paths } from "../../../paths";

export const grossProductCollectionApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

	getGrossProductCollectionListAll: builder.query<ResponseDataGet<EntGrossProductCollection>, EntGrossProductCollectionFilter>({
	  query: (filter) => ({
		url: `${ Paths.organic.grossproductioncooperative }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getGrossProductCollectionById: builder.query<ResponseDataTest<EntGrossProductCollection>, number>({
	  query: (id) => ({
		url: `${ Paths.organic.grossproductioncooperative }/${ id }`,
		method: 'GET'
	  })
	}),
	addGrossProductCollection: builder.mutation<ResponseDataTest<EntGrossProductCollection>, EntGrossProductCollection>({
	  query: (body) => ({
		url: `${ Paths.organic.grossproductioncooperative }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editGrossProductCollection: builder.mutation<ResponseDataTest<EntGrossProductCollection>, EntGrossProductCollection>({
	  query: (body) => ({
		url: `${ Paths.organic.grossproductioncooperative }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteGrossProductCollection: builder.mutation<ResponseDataTest<EntGrossProductCollection>, number>({
	  query: (id) => ({
		url: `${ Paths.organic.grossproductioncooperative }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddGrossProductCollectionMutation,
  useDeleteGrossProductCollectionMutation,
  useEditGrossProductCollectionMutation,
  useGetGrossProductCollectionByIdQuery,
  useGetGrossProductCollectionListAllQuery,
  useLazyGetGrossProductCollectionListAllQuery
} = grossProductCollectionApi;
